module.exports = __webpack_public_path__ + "img/pin-node-500.9d54cee2.png";